export default __webpack_public_path__ + "static/media/copy.58d16222.svg";